import { Component, OnDestroy, OnInit } from '@angular/core';
import { MatButtonToggle, MatButtonToggleGroup } from '@angular/material/button-toggle';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { Store } from '@ngrx/store';
import { AppState } from '../../../store';
import { selectShipmentEditorCategory } from '../../../store/shipment-editor/shipment-editor.state';
import { Subscription } from 'rxjs';
import { shipmentEditorSetCategory } from '../../../store/shipment-editor/shipment-editor.actions';

@Component({
    selector: 'app-shipment-category',
    imports: [
        MatButtonToggle,
        MatButtonToggleGroup,
        ReactiveFormsModule
    ],
    templateUrl: './shipment-category.component.html',
    styleUrl: './shipment-category.component.scss'
})
export class ShipmentCategoryComponent implements OnInit, OnDestroy {

    categoryControl = new FormControl<string>('parcel', { nonNullable: true });

    private stateSubscription: Subscription;
    private controlSubscription: Subscription;

    constructor(private store: Store<AppState>) {}

    ngOnInit(): void {
        this.stateSubscription = this.store.select(selectShipmentEditorCategory).subscribe(
            category => this.categoryControl.setValue(category, { emitEvent: false })
        );
        this.controlSubscription = this.categoryControl.valueChanges.subscribe(
            category => this.store.dispatch(shipmentEditorSetCategory({ category }))
        );
    }

    ngOnDestroy(): void {
        this.stateSubscription.unsubscribe();
        this.controlSubscription.unsubscribe();
    }
}
